/* eslint-disable no-console */
import { SourceMapConsumer } from 'source-map-js';

let sourceMapConsumerPromise = null;

// Load source map only once (handle async properly)
function loadSourceMap() {
  if (!sourceMapConsumerPromise) {
    sourceMapConsumerPromise = fetch('/bundle.js.map')
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to fetch source map: ${res.statusText}`);
        }
        return res.text();
      })
      .then((mapText) => new SourceMapConsumer(mapText));
  }
  return sourceMapConsumerPromise;
}

export default function logWrapper(fn, isDebug = true) {
  const name = fn.name || 'anonymous';

  return function (...args) {
    if (isDebug) {
      const timestamp = new Date().toISOString();
      const stack = new Error().stack?.split('\n') || [];

      const match = stack[2]?.match(/:(\d+):(\d+)/);

      if (match) {
        const [, line, column] = match.map(Number);

        loadSourceMap()
          .then((consumer) => {
            const pos = consumer.originalPositionFor({ line, column });

            console.log(
              `[${timestamp}] [LOG] Calling: ${name} at ${pos.source}:${pos.line}:${pos.column}`
            );
          })
          .catch((err) => {
            console.warn('Source map failed to load or parse', err);
          });
      } else {
        console.log(`[${timestamp}] [LOG] Calling: ${name} (no match)`);
      }
    }

    return fn.apply(this, args);
  };
}
